import { render, staticRenderFns } from "./apps.vue?vue&type=template&id=89809092&"
import script from "./apps.vue?vue&type=script&lang=ts&"
export * from "./apps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports